import type {TextEditorSelection} from '../types/TextEditorApi';

export function normalizeTextEditorSelection(
  selection: TextEditorSelection,
  isStructuralBreakAt: (index: number) => boolean
): TextEditorSelection | null {
  let length = selection.length;

  while (length > 0 && isStructuralBreakAt(selection.index + length - 1)) {
    length = length - 1;
  }

  return length === 0 ? null : {...selection, length};
}
